'use strict';

const React = require('react');
const PropTypes = require('prop-types');

function ViewInvoiceLink({ itemId, onClick, children, className }) {
    return (
        <a
            href={`/my/orders/invoice/id-${itemId}/`}
            target="_blank"
            className={className}
            onClick={onClick}
        >
            {children}
        </a>
    );
}

ViewInvoiceLink.defaultProps = {
    onClick: () => {},
};

ViewInvoiceLink.propTypes = {
    itemId: PropTypes.string.isRequired,
    viewer: PropTypes.object,
    user: PropTypes.object,
    onClick: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
};

module.exports = ViewInvoiceLink;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Invoice/ViewInvoiceLink.jsx